import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SalesRequestCreditBureauComponent} from "./sales-request-credit-bureau.component";
import {SalesRequestCreditBureauComponentV3} from "./versions/sales-request-credit-bureau-versions.component";
import {LibraryModule} from "library";
import {PrimengModule} from "../../shared/primeng-module/primeng.module";
import {ReactiveFormsModule, FormsModule} from "@angular/forms";
import {GeneralModule} from "../general/general.module";

@NgModule({
  declarations: [
    SalesRequestCreditBureauComponent,
    SalesRequestCreditBureauComponentV3
  ],
  imports: [
    CommonModule,
    LibraryModule,
    PrimengModule,
    ReactiveFormsModule,
    FormsModule,
    GeneralModule
  ],
  exports: [
    SalesRequestCreditBureauComponent,
    SalesRequestCreditBureauComponentV3
  ]
})
export class SalesRequestCreditBureauModule { }